import React from "react";
import { withRouter } from "react-router-dom";

import {
  SidebarVideoSquirrelLogo,
  SidebarGroup,
  SidebarItem,
  SidebarProfileFooter
} from "./";
import { useResponsive } from "react-hooks-responsive";

import { useHistory } from "react-router-dom";

import styles from "./Sidebar.module.scss";
import useTutorialsState from "../../hooks/useTutorialsState";

function Sidebar({ location }) {
  const history = useHistory();
  const { isNmiAccount } = useTutorialsState();
  const { size } = useResponsive({ xs: 0, sm: 480, md: 1200 });
  const collapsed = size !== "md";
  if (
    location.pathname === "/login" ||
    location.pathname === "/forgotPassword" ||
    location.pathname === "/influencer/login" ||
    location.pathname === "/influencer/register" ||
    location.pathname.startsWith("/register") ||
    location.pathname.startsWith("/share") ||
    location.pathname.startsWith("/brand")
  )
    return null;

  const windowLocation = location.pathname.split("/").filter((l) => !!l)[0];

  return (
    <nav className={styles.sidebar}>
      <div>
        <SidebarVideoSquirrelLogo collapsed={collapsed} />

        <SidebarGroup>
          <SidebarItem
            active={windowLocation === "dashboard"}
            icon="home"
            label="Dashboard"
            collapsed={collapsed}
            onClick={() => {
              history.push("/dashboard");
            }}
          />
          <SidebarItem
            active={windowLocation === "products"}
            icon="Products"
            label="Products"
            collapsed={collapsed}
            onClick={() => {
              history.push("/products");
            }}
          />
          <SidebarItem
            active={windowLocation === "orders"}
            icon="Orders"
            label="Orders"
            collapsed={collapsed}
            onClick={() => {
              history.push("/orders");
            }}
          />
          <SidebarItem
            active={windowLocation === "opportunities"}
            icon="Highlights"
            label="Opportunities"
            collapsed={collapsed}
            onClick={() => history.push("/opportunities")}
          />
          <SidebarItem
            active={windowLocation === "videos"}
            icon="Videos"
            label="Videos"
            collapsed={collapsed}
            onClick={() => history.push("/videos")}
          />
          <SidebarItem
            active={windowLocation === "reporting"}
            icon="Application"
            label="Reporting"
            collapsed={collapsed}
            onClick={() => {
              history.push("/reporting");
            }}
          />
          {!isNmiAccount && (
            <SidebarItem
              active={windowLocation === "cashout"}
              icon="Cash-Out"
              label="Cash Out"
              collapsed={collapsed}
              onClick={() => {
                history.push("/cashout");
              }}
            />
          )}
        </SidebarGroup>
        <div className={styles.divider} />
        <SidebarGroup>
          <SidebarItem
            active={windowLocation === "settings"}
            icon="cog"
            label="Settings"
            collapsed={collapsed}
            onClick={() => {
              history.push("/settings/profile");
            }}
          />
        </SidebarGroup>
        <div className={styles.bottomDivider} />
      </div>

      <SidebarProfileFooter collapsed={collapsed} />
    </nav>
  );
}

export default withRouter(Sidebar);
